import AdvancedVisualisationErrorBoundary from 'workflow/CampaignSummary/PhraseeXContent/AdvancedVisualisations/AdvancedVisualisationErrorBoundary'

import Loader from 'common/components/loaders/Loader'
import { WidgetError } from 'common/components/WidgetMessage'
import { useAppSelector } from 'common/hooks/redux'

import { GraphsModuleProps } from '../../interface'

const GraphsModule = ({
  requestedGraphType,
  requestedGraphTemplate,
  renderAdvancedVisualisationGraph,
  requestedGraphOrdinal,
  variantColorMapping,
}: GraphsModuleProps) => {
  // Redux state data
  const {
    advancedVisualisationsLoading,
    advancedVisualisationsData,
    advancedVisualisationsError,
  } = useAppSelector((state) => state.campaignStates)
  // end Redux state data

  return (
    <>
      <>
        {advancedVisualisationsLoading ? (
          <Loader data-testid="GraphLoader" className="py-20" />
        ) : advancedVisualisationsError ? (
          <WidgetError className="mt-6 mx-6" />
        ) : !!advancedVisualisationsData[requestedGraphTemplate] ? (
          <AdvancedVisualisationErrorBoundary>
            {renderAdvancedVisualisationGraph(
              requestedGraphType,
              advancedVisualisationsData[requestedGraphTemplate],
              requestedGraphOrdinal,
              variantColorMapping,
              requestedGraphTemplate
            )}
          </AdvancedVisualisationErrorBoundary>
        ) : (
          <WidgetError className="mt-6 mx-6" />
        )}
      </>
    </>
  )
}

export default GraphsModule
